/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  ControlValueAccessor,
  FormControl,
  FormControlName,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import {
  Input,
  Component,
  forwardRef,
  HostListener,
  ViewChild,
  ElementRef,
  OnInit,
  EventEmitter,
  Output,
} from "@angular/core";
import { REGEX } from "../../../config/app.config";
import { EInputStyleType } from "../../../data-types/input-style.enum";
import { iconsLibrary } from "../../../../theme/constants";

import { Store } from "@ngrx/store";
import { IAppState } from "../../../store/state/app.state";

declare var H: any;

@Component({
  selector: "cowing-input-location",
  templateUrl: "./cowing-input-location.component.html",
  styleUrls: ["./cowing-input-location.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CowingInputLocationComponent),
      multi: true,
    },
  ],
})
export class CowingInputLocationComponent
  implements ControlValueAccessor, OnInit
{
  onClick(event) {}

  @Input("value") value: string;
  @Input("type") type: string = "text";
  @Input("inputStyle") inputStyle: string = EInputStyleType.Primary;
  @Input("iconShow") iconShow: boolean = false;
  @Input("iconName") iconName: string = "";
  @Input("label") label: string = "";
  @Input("placeholder") placeholder: string = "";
  @Input("required") required: boolean = false;
  @Input("validateInput") validateInput: boolean = true;
  @Input("isForm") isForm: boolean = false;
  @Input("control") control: FormControl = null;

  @ViewChild("input") input: ElementRef;
  @Output("setLocation") locationEvent = new EventEmitter();

  public platform: any;
  public geocoder: any;
  keyboard: any;
  toggledShowPassword = false;
  valid = false;
  checked: boolean;
  msg = "";
  status = "";
  private internalInputChange;
  private init = true;
  constructor() {
    this.platform = new H.service.Platform({
      apikey: "NogSDLNDmk3LGE8LE55oFPl3EPDeimpgGLBuk3ynCCE",
    });
    this.geocoder = this.platform.getGeocodingService();
  }

  ngOnInit() {
    if (this.control.value && this.control.value !== "") {
      this.validateLocation();
    }
  }
  public validateLocation() {
    this.getAddress(this.control.value)
      .then((result: any) => {
        this.valid = true;
        this.locationEvent.emit(result);
      })
      .catch((error: any) => {
        console.error(error);
        this.valid = false;
      });
  }

  public getAddress(searchText: string) {
    return new Promise((resolve, reject) => {
      this.geocoder.geocode({ searchText }, (result) => {
        if (result.Response.View.length !== 0) {
          let location =
            result.Response.View[0].Result[0].Location.DisplayPosition;
          this.value = result.Response.View[0].Result[0].Location.Address.Label;
          let province =
            result.Response.View[0].Result[0].Location.Address.County;
          let country =
            result.Response.View[0].Result[0].Location.Address.Country;
          let city = result.Response.View[0].Result[0].Location.Address.City;
          // let = result.Response.View[0].Result[0].Location.Address.Label;
          if (this.isForm) {
            this.control.setValue(this.value);
            this.control.updateValueAndValidity();
          }
          resolve({
            country,
            province,
            city,
            lat: location.Latitude,
            lng: location.Longitude,
          });
        } else {
          reject();
        }
      });
    });
  }

  public onInputChange($event?: any) {
    if ($event) {
      this.value = $event.target.value;
      this.internalInputChange(this.value);
    }
  }

  public get getIcon() {
    if (this.iconName) {
      return `${iconsLibrary[this.iconName]}`;
    }
    return "";
  }

  // toggleShowPassword() {
  //   this.toggledShowPassword = !this.toggledShowPassword;
  //   this.type = this.toggledShowPassword ? "text" : "password";
  // }

  writeValue(value: any): void {
    if (value) {
      this.value = value;
    }
  }
  registerOnChange(fn: any): void {
    this.internalInputChange = fn;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error("Method not implemented.");
  }

  onChangeKeyboard(input) {
    this.value = input;
    this.internalInputChange(this.value);
    console.log("Input changed", input);
  }

  onKeyPress(button) {
    console.log("Button pressed", button);
  }
}
